import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ENVIRONMENT, Environment, CoreNetworkGroup } from '@netfoundry-ui/shared/model';
import {
  HateoasResourceOperation,
} from '@lagoshny/ngx-hateoas-client';
import { throwError as observableThrowError } from 'rxjs/internal/observable/throwError';
import { catchError } from 'rxjs/operators';
import { HTTP_CLIENT } from './token.service';
import { LoggerService } from './logger.service';


@Injectable({ providedIn: 'root' })
export class CoreNetworkGroupService extends HateoasResourceOperation<CoreNetworkGroup> {
    static readonly defaultHttpAccept = {
        headers: { accept: 'application/hal+json' },
        pageParams: {
            page: 0,
            size: 2000,
        },
    };
    apiUrl;

    constructor(
        private readonly logger: LoggerService,
        @Inject(HTTP_CLIENT) private readonly http: HttpClient,
        @Inject(ENVIRONMENT) private readonly environment: Environment
    ) {
        super(CoreNetworkGroup);
        this.apiUrl = this.environment.v3apiUrl;
    }

    public getNetworkGroup(networkGroupId: string) {
        const fullpath = `${this.apiUrl}network-groups/${networkGroupId}`;
        return this.http.get(fullpath);
    }

    public getNetworksForGroup(networkGroupId: string) {
        const fullpath = `${this.apiUrl}/networks?networkGroupId=${networkGroupId}&platformVersion=7,8`;
        return this.http.get(fullpath);
    }
}
